import { createSlice } from '@reduxjs/toolkit'

import { TAB_PCB_PARTS, TAB_ASSEMBLY  } from 'shared/product_tabs/tabs/data/tabType';

const isValidTab = (tab) => {
  return tab === TAB_PCB_PARTS || tab === TAB_ASSEMBLY;
};

let initialTab;
if (isValidTab(Spree.active_tab)) {
  initialTab = Spree.active_tab;
} else if (Spree.assembly) {
  initialTab = TAB_ASSEMBLY;
} else if (Spree.parts) {
  initialTab = TAB_PCB_PARTS;
} else {
  initialTab = TAB_ASSEMBLY;
}

const tabService = createSlice({
  name: "tabService",
  initialState: {
    activeTab: initialTab,
  },
  reducers: {
    changeTab(state, action) {
      state.activeTab = action.payload;
    },
  },
});

export const { changeTab } = tabService.actions;

export default tabService.reducer;
